import { AsyncValidatorFn, ValidatorFn } from '@angular/forms';

export type ValidationSeverity = 'INVALID' | 'WARNING';

export interface ValidationError {
  message: string;
  severity: ValidationSeverity;
  validationFn: ValidatorFn | null;
  asyncValidationFn: AsyncValidatorFn | null;
}

export class FieldValidation {
  errorCodeMap: { [key: string]: ValidationError } = {};

  addValidationError(codeMapEntries: { [key: string]: ValidationError }): void {
    this.errorCodeMap = { ...this.errorCodeMap, ...codeMapEntries };
  }

  getAsyncValidators(): AsyncValidatorFn[] {
    const asyncValidators = [];
    for (const errorValue of Object.values(this.errorCodeMap)) {
      if (errorValue.asyncValidationFn && errorValue.severity === 'INVALID') {
        asyncValidators.push(errorValue.asyncValidationFn);
      }
    }
    return asyncValidators;
  }

  getValidators(): ValidatorFn[] {
    const validators = [];
    for (const errorValue of Object.values(this.errorCodeMap)) {
      if (errorValue.validationFn && errorValue.severity === 'INVALID') {
        validators.push(errorValue.validationFn);
      }
    }
    return validators;
  }

  getAsyncWarningValidators(): AsyncValidatorFn[] {
    const asyncValidators = [];
    for (const errorValue of Object.values(this.errorCodeMap)) {
      if (errorValue.asyncValidationFn && errorValue.severity === 'WARNING') {
        asyncValidators.push(errorValue.asyncValidationFn);
      }
    }
    return asyncValidators;
  }

  getWarningValidators(): ValidatorFn[] {
    const validators = [];
    for (const errorValue of Object.values(this.errorCodeMap)) {
      if (errorValue.validationFn && errorValue.severity === 'WARNING') {
        validators.push(errorValue.validationFn);
      }
    }
    return validators;
  }
}
